/* eslint-disable react/jsx-pascal-case */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import {
  Set_SliceWmsPhysicalStockCount_CountingDetail_Init,
  Set_SliceWmsPhysicalStockCount_CountingDetail,
  Set_SliceWmsPhysicalStockCount_FilterCounting,
} from "./SliceWmsPhysicalStockCount";
import { fAlertToast } from "../../Utility/Utilitys";
import WmsPhysicalStockCount_BreadCrumbs from "./WmsPhysicalStockCount_BreadCrumbs";
import useMediaQuery from "@mui/material/useMediaQuery";
import {
  PhysicalStockCount_Count_Reverse,
  PhysicalStockCount_Count_Summary,
  PhysicalStockCount_Summary_Attribute,
  Physical_Stock_Count_Approve,
} from "../../Server/ApiV2";
import { vRdxUserInfo } from "../../Redux/roStore";
import { WmsPhysicalStockCountingCard } from "./processComponent/WmsPhysicalStockCountingCard";
import { confirmAlert } from "react-confirm-alert";
import {
  CmpButton,
  CmpSelectBox,
  CmpTextFieldEnter,
  CmpTypographyField,
} from "../../Component/Common/ToolBox/ToolBox";
import GCSummaryModal from "../../Component/Common/ReuseableComponent/GCSummaryModal";
import GCLgAutocomplete from "../../Component/Common/ReuseableComponent/GCLgAutocomplete";
import { Grid } from "@mui/material";
import { CountArr, StatusArr } from "./WmsPhysicalStockCountAction";
import GCFilter from "./processComponent/GCFilter";

export default function WmsPhysicalStockCounting() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const vRdxuserInfo = useSelector((state) => state.login.value);
  const summaryObj = useSelector(
    (state) => state.SliceWmsPhysicalStockCount.value.FilterCounting
  );
  const LocationFocusOnLoad = useRef(null);
  // const [summaryObj, setSummaryObj] = useState({
  //   // filter select value
  //   v_Loc: "",
  //   AisleCode: [{ UId: "All", Name1: "All" }],
  //   AisleCSV: "All",
  //   LevelCode: [{ UId: "All", Name1: "All" }],
  //   LevelCSV: "All",
  //   v_countTyp: CountArr[0].UID,
  //   v_Status: StatusArr[0].id,
  // });
  const [GridDataColumnsWmsSiDetail, setGridDataColumnsWmsSiDetail] = useState([
    { field: "id", headerName: "ID", width: 70, hide: true },
    { field: "binName", headerName: "Bin", width: 150, },
    { field: "userName", headerName: "User", width: 150, hide: false },
    { field: "countStatus", headerName: "Status", width: 100, hide: false },

    {
      field: "ReOpen",
      headerName: "Re-Open",
      hide: false,
      width: 100,
      renderCell: (params) => {
        return (
          <Button
            size="small"
            color="primary"
            onClick={async (items) => {
              items.stopPropagation(); 
              console.log("Re-Open Button Clicked:", params.row); // Debugging log
              if (params.row.Admin == "Y") {
                confirmAlert({
                  title: "Open Bin",
                  message: "Are you want to Open Bin.",
                  buttons: [
                    {
                      className: "alertBtn",
                      name: "DeletYes",
                      label: "Yes",
                      onClick: async () => {
                        let resp = await PhysicalStockCount_Count_Reverse({
                          SheetId: params.row.sheetID,
                          BinCd: params.row.binCode,
                          Status: "ENTER",
                        });
                        if (resp.status == 200) {
                          fAlertToast("SUCCESS", "Successfully reversed");
                          fetchSummaryData();
                        }
                      },
                    },
                    {
                      className: "alertBtn",
                      label: "No",
                      onClick: () => "",
                    },
                  ],
                });
              }
            }}
          >
            Re-Open
          </Button>
        );
      },
    },

    { field: "sheetID", headerName: "Sheet ID", width: 150 },

    { field: "locName", headerName: "location", width: 100, hide: false },
    { field: "date", headerName: "Date", width: 100 },
    { field: "countTyp", headerName: "Count", width: 100, hide: false },
  ]);
  const [summaryData, setSummaryData] = useState([]); // resp main  screen

  const [summaryDropdownArray, setSummaryDropdownArray] = useState({
    // to show list
    Level: [],
    Asile: [],
  });

  // modal start
  const [showModal, setShowModal] = useState(false);
  // modal end

  const fSummary_OnChange = (e) => {
    dispatch(
      Set_SliceWmsPhysicalStockCount_FilterCounting({
        ...summaryObj,
        [e.target.name]: e.target.value,
      })
    );
    // setSummaryObj((prevState) => ({
    //   ...prevState,
    //   [e.target.name]: e.target.value,
    // }));
  };

  const handleAutocompleteLevelChange = (event, newValue) => {
    let currentPrnt = newValue.map((option) => option.UId).join(",");
    // setSummaryObj((prevObj) => ({
    //   ...prevObj,
    //   LevelCode: newValue,
    //   LevelCSV: currentPrnt,
    // }));
    dispatch(
      Set_SliceWmsPhysicalStockCount_FilterCounting({
        ...summaryObj,
        LevelCode: newValue,
        LevelCSV: currentPrnt,
      })
    );
  };

  const handleAutocompleteAsileChange = (event, newValue) => {
    let currentPrnt = newValue.map((option) => option.UId).join(",");
    // setSummaryObj((prevObj) => ({
    //   ...prevObj,
    //   AisleCode: newValue,
    //   AisleCSV: currentPrnt,
    // }));
    dispatch(
      Set_SliceWmsPhysicalStockCount_FilterCounting({
        ...summaryObj,
        AisleCode: newValue,
        AisleCSV: currentPrnt,
      })
    );
  };

  const fLoad = (e) => {
    fetchSummaryData();
  };

  const fetchSummaryData = async (xLocation = summaryObj.v_Loc) => {
    const vRdxUserInfoObj = vRdxUserInfo();
    let vSummaryListObj = {
      v_UserCd: vRdxUserInfoObj.UserID,
      v_AisleCd: summaryObj.AisleCSV,
      v_LVL: summaryObj.LevelCSV,
      v_Loc: xLocation,
      v_countTyp: summaryObj.v_countTyp,
      v_Status: summaryObj.v_Status,
    };

    const vSummaryList = await PhysicalStockCount_Count_Summary(
      vSummaryListObj
    );

    if (vSummaryList.status == 200) {
      let row = vSummaryList.data.ResultSet.map((obj, i) => ({
        ...obj,
        id: i + 1,
      }));
      setSummaryData(row);
    }

    setShowModal(false);
  };

  const getAttributeData = async () => {
    const vRdxUserInfoObj = vRdxUserInfo();
    var obj = {
      userCd: vRdxUserInfoObj.UserID,
    };
    const vSummaryList = await PhysicalStockCount_Summary_Attribute(obj);

    if (vSummaryList.status == 200) {
      setSummaryDropdownArray(vSummaryList.data.ResultSet);
      return vSummaryList.data.ResultSet;
    }
  };

  const onload = async () => {
    // dispatch(Set_SliceWmsPhysicalStockCount_CountingDetail_Init());
    let iresp = await getAttributeData();
    dispatch(
      Set_SliceWmsPhysicalStockCount_FilterCounting({
        ...summaryObj,
        v_Loc:
          summaryObj.v_Loc == "" ? iresp.Location[0].UID : summaryObj.v_Loc,
      })
    );
    await fetchSummaryData(
      summaryObj.v_Loc == "" ? iresp.Location[0].UID : summaryObj.v_Loc
    );
    // setSummaryObj((obj) => ({
    //   ...obj,
    //   v_Loc: iresp.Location[0].UID,
    // }));
  };
  useEffect(() => {
    onload();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    console.log("summaryObj", summaryObj);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [summaryObj]);

  useEffect(() => {
    LocationFocusOnLoad.current?.focus();
  }, []);

  return (
    <div className="container-fluid my-3">
      <div className="Breadcrumbs d-flex justify-content-between align-items-center">
        <WmsPhysicalStockCount_BreadCrumbs />
        <CmpButton
          xbtnName="Filter"
          xOnClick={() => {
            setShowModal(true);
          }}
          xVariant="contained"
          xSize="small"
        />
      </div>

      <div className="Instant-picking-head">
        <div style={{ height: "75vh", width: "100%" }}>
          <DataGrid
            rowHeight={30}
            headerHeight={40}
            getRowClassName={(params) =>
              params.indexRelativeToCurrentPage % 2 === 0
                ? "mui-even-row"
                : "mui-odd-row"
            }
            sx={{
              border: 1,
              borderColor: "primary.light",
               borderColor: 'primary.light',
                  '& .MuiDataGrid-columnHeaders': {
                    backgroundColor: '#0d73bb',
                    color: 'white'
                  },
            }}
            rows={summaryData}
            columns={GridDataColumnsWmsSiDetail}
            onRowClick={(items) => {
              if (items.field !== "ReOpen") { // Ignore clicks on the "Re-Open" column
                dispatch(
                  Set_SliceWmsPhysicalStockCount_CountingDetail(items.row)
                );
                console.log(items);
                navigate("/WmsPhysicalStockDetail");
              }
             
            }}
            hideFooter={summaryData.length < 100}

            // components={{
            //   Toolbar: GridToolbar,
            // }}
          />
        </div>
        {/* <WmsPhysicalStockCountingCard
          data={summaryData}
          onClick={(items) => {
            dispatch(Set_SliceWmsPhysicalStockCount_CountingDetail(items.row));
            console.log(items);
            navigate("/WmsPhysicalStockDetail");
          }}
          ReOpen={async (items) => {
            if (items.row.Admin == "Y") {
              confirmAlert({
                title: "Open Bin",
                message: "Are you want to Open Bin.",
                buttons: [
                  {
                    className: "alertBtn",
                    name: "DeletYes",
                    label: "Yes",
                    onClick: async () => {
                      let resp = await PhysicalStockCount_Count_Reverse({
                        SheetId: items.row.sheetID,
                        BinCd: items.row.binCode,
                        Status: "ENTER",
                      });
                      if (resp.status == 200) {
                        fAlertToast("SUCCESS", "Successfully reversed");
                        fetchSummaryData();
                      }
                    },
                  },
                  {
                    className: "alertBtn",
                    label: "No",
                    onClick: () => "",
                  },
                ],
              });
            }
          }}
        /> */}
      </div>
      <GCFilter
        xOpen={showModal}
        fCloseModal={() => {
          setShowModal(false);
        }}
        xTitle="Filter Modal"
        component={
          <>
            <Grid
              container
              spacing={{ xs: 2, sm: 2, md: 2 }}
              className="align-items-center"
              columns={{ xs: 12, sm: 12, md: 12 }}
            >
              <Grid item xs={3} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Location"} />
              </Grid>
              <Grid item xs={9} md={10}>
                <CmpSelectBox
                  xref={LocationFocusOnLoad}
                  // xLabelText="Location"
                  xValue={summaryObj.v_Loc}
                  xOnChange={fSummary_OnChange}
                  xName={"v_Loc"}
                  xData={summaryDropdownArray?.Location}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={3} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"AisleCode"} />
              </Grid>
              <Grid item xs={9} md={10} className="bintransfer-data-date">
                <GCLgAutocomplete
                  // xtabIndex={"10"}
                  // xLabelText="AisleCode"
                  xValue={summaryObj.AisleCode}
                  options={summaryDropdownArray.Asile}
                  handleChange={handleAutocompleteAsileChange}
                />
              </Grid>
              <Grid item xs={3} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"CountType"} />
              </Grid>
              <Grid item xs={9} md={10} className="bintransfer-data-date">
                <CmpSelectBox
                  xref={LocationFocusOnLoad}
                  // xLabelText="Count"
                  xValue={summaryObj.v_countTyp}
                  xOnChange={fSummary_OnChange}
                  xName={"v_countTyp"}
                  xData={CountArr}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={3} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Status"} />
              </Grid>
              <Grid item xs={9} md={10} className="bintransfer-data-date">
                <CmpSelectBox
                  xref={LocationFocusOnLoad}
                  // xLabelText="Status"
                  xValue={summaryObj.v_Status}
                  xOnChange={fSummary_OnChange}
                  xName={"v_Status"}
                  xData={StatusArr}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={false}
                  xErrorMessage={false}
                  xDisable={false}
                />
              </Grid>
              <Grid item xs={3} md={2}>
                <CmpTypographyField xcomponent={"span"} xText={"Level"} />
              </Grid>
              <Grid item xs={9} md={10} className="bintransfer-data-date">
                <GCLgAutocomplete
                  // xLabelText="Level"
                  // xtabIndex={"10"}
                  xValue={summaryObj.LevelCode}
                  options={summaryDropdownArray.Level}
                  handleChange={handleAutocompleteLevelChange}
                />
              </Grid>
              <Grid
                item
                // lg={2}
                // md={4}
                xs={12}
                className="bintransfet-data-load-btn text-center"
              >
                <CmpButton
                  xbtnName="Load"
                  xOnClick={fLoad}
                  xVariant="contained"
                  xSize="small"
                />
              </Grid>
            </Grid>
          </>
        }
      />
    </div>
  );
}
